import { api } from 'api';

const prepareData = (data) => {
  const out = { ...data };
  out.min_amount = parseInt(out.min_amount) * 100;
  out.amount = parseInt(out.amount) * 100;
  return out;
};

/**
 * add
 * @param {*} data
 * @returns
 */
export const addBenefit = (data) => {
  return api.call('benefit_types.check_add', prepareData(data));
};

/**
 * update
 * @param {*} data
 * @returns
 */
export const updateBenefit = (data) => {
  return api.call('benefit_types.check_update', prepareData(data));
};
